export class ObjectPool<T> {
    private _pool: T[] = [];

    constructor(private _build: (params) => T) {

    }

    public put(obj: T) {
        this._pool.push(obj);
    }

    public get(params: any = null): {isNew: boolean, instance: T} {
        let instance;
        let isNew = true;
        if(this._pool.length) {
            instance = this._pool.pop();
            isNew = false;
        } else {
            instance = this._build(params);
        }

        return {
            isNew,
            instance
        }
    }
}